import { useTranslation } from 'react-i18next'

import styles from './pure-header.module.scss'

type PureHeaderProps = {
  value?: string
  headerPlaceholder?: string
  label?: string
}

export const PureHeader = ({ value = 'Header', headerPlaceholder, label }: PureHeaderProps) => {
  const { t } = useTranslation()

  let headerValue = value
  if (label) {
    headerValue = label
  }
  if (headerPlaceholder) {
    headerValue = String(headerPlaceholder)
  }
  if (!value && !!headerValue) {
    headerValue = t('formBuilder.header')
  }

  return <h4 className={styles.pureHeader}>{headerValue}</h4>
}
